module.exports = __webpack_public_path__ + "img/COMBO FLOWER LIME.63710a2.svg";